// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_5FC","cls2":"DebugPage-cls2_jzo DebugPage-cls1_5FC"};